export default <S, A>(
  getHandler: (action: A) => CallableFunction,
) => (state: S, action: A): S => {
  const handler = getHandler(action);
  if (handler) {
    return handler(state, action);
  }
  return state;
};
